import { Button } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import Can, { type CanEstado } from "@/permissoes/Can";
import { PERMISSOES_RESTRICOES } from "@/permissoes/restricoes/restricoes.constants";

// --------------------------------- TYPES ---------------------------------
export type RodapeAcoesModalProps = {
	readonly permissaoSalvar: CanEstado;
	readonly salvarBloqueado: boolean;
	readonly temAlteracoes: boolean;
	readonly salvando: boolean;
	readonly onDescartar: () => void;
	readonly onCancelar: () => void;
	readonly onSalvar: () => void;
};

// ------------------------------- COMPONENT -------------------------------
export default function RodapeAcoesModal({
	permissaoSalvar,
	salvarBloqueado,
	temAlteracoes,
	salvando,
	onDescartar,
	onCancelar,
	onSalvar,
}: Readonly<RodapeAcoesModalProps>) {
	return (
		<>
			{temAlteracoes ? (
				<Button
					variant="capsuleOutlined"
					color="warning"
					size="small"
					onClick={onDescartar}
					disabled={salvando}
					startIcon={<FuseSvgIcon size={18}>lucide:rotate-ccw</FuseSvgIcon>}
				>
					Descartar alterações
				</Button>
			) : null}
			<Button
				variant="capsuleOutlined"
				color="error"
				size="small"
				onClick={onCancelar}
				disabled={salvando}
				startIcon={<FuseSvgIcon size={18}>lucide:x</FuseSvgIcon>}
			>
				Cancelar
			</Button>
			<Can
				tag={PERMISSOES_RESTRICOES.salvar}
				tipoGrupo="USUARIO"
				modo="desabilitar"
				estado={permissaoSalvar}
				tooltip={
					permissaoSalvar.carregando
						? "Verificando permissão para salvar restrições…"
						: "Você não tem permissão para salvar restrições."
				}
				tooltipPlacement="right"
			>
				<Button
					variant="capsule"
					color="success"
					size="small"
					onClick={onSalvar}
					disabled={
						salvando ||
						!temAlteracoes ||
						salvarBloqueado ||
						!permissaoSalvar.permitido ||
						permissaoSalvar.carregando
					}
					startIcon={<FuseSvgIcon size={18}>lucide:save</FuseSvgIcon>}
				>
					{salvando ? "Salvando…" : "Salvar alterações"}
				</Button>
			</Can>
		</>
	);
}
